module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-580x2-c782c2ebd0b64b9c355ccc07e813e59a.webp";